import { SVGProps, Ref, forwardRef } from 'react'
const SvgColorSpotify = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fill="#1ED760"
      fillRule="evenodd"
      d="M1.033 12.003C1.033 5.946 5.943 1.036 12 1.036c6.058 0 10.967 4.91 10.967 10.967 0 6.056-4.91 10.966-10.967 10.966-6.056 0-10.966-4.91-10.966-10.966Zm15.055 5.076a.683.683 0 1 0 .714-1.166c-2.89-1.767-6.474-2.178-10.651-1.223a.683.683 0 1 0 .304 1.333c3.817-.873 7.059-.516 9.633 1.056Zm2.283-3.213a.855.855 0 0 1-1.176.283c-2.947-1.813-7.44-2.337-10.927-1.279a.856.856 0 0 1-.497-1.636c3.983-1.208 8.934-.623 12.319 1.457.402.248.529.774.281 1.175ZM5.745 9.49c3.375-1.024 9.206-.831 12.74 1.268h.001a1.025 1.025 0 1 0 1.046-1.764C15.463 6.577 9.024 6.35 5.15 7.526a1.026 1.026 0 0 0 .595 1.963Z"
      clipRule="evenodd"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgColorSpotify)
export default ForwardRef
